import { render, staticRenderFns } from "./MongoViewEdit.vue?vue&type=template&id=7f11df83&scoped=true"
import script from "./MongoViewEdit.vue?vue&type=script&lang=ts"
export * from "./MongoViewEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f11df83",
  null
  
)

export default component.exports